import Reveal from '@/components/base/Reveal';
import SectionLabel from '@/components/base/SectionLabel';
import { collections } from '../data';

export default function Collections() {
  return (
    <section id="collections" className="bg-background-100 py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Reveal className="max-w-2xl">
          <SectionLabel>Our Collection</SectionLabel>
          <h2 className="mt-4 font-heading text-4xl md:text-5xl leading-[1.12] font-medium text-foreground-950">
            Traditional Styles for Every Occasion
          </h2>
          <p className="mt-4 text-[15px] md:text-base leading-relaxed text-foreground-700">
            Explore a selection of traditional Indian clothing and textiles available through
            SRM Textiles.
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {collections.map((item, i) => (
            <Reveal key={item.title} delay={i * 90}>
              <div className="block">
                <div className="img-zoom rounded-lg overflow-hidden">
                  <img
                    src={item.image}
                    alt={`${item.title} collection of traditional Indian textiles and clothing`}
                    className="h-72 md:h-80 w-full object-cover object-top"
                  />
                </div>
                <div className="mt-5">
                  <h3 className="font-heading text-2xl font-semibold text-foreground-950">{item.title}</h3>
                  <p className="mt-2 text-[13px] leading-relaxed text-foreground-600">{item.subtitle}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-10">
          <a
            href="#contact"
            className="inline-flex items-center gap-2 whitespace-nowrap text-sm font-semibold text-primary-600 hover:text-primary-500"
          >
            Explore the Collection
            <i className="ri-arrow-right-line" aria-hidden="true" />
          </a>
        </Reveal>
      </div>
    </section>
  );
}